<template>
  <div class="fcc-gallery">
    <div class="holder">
      <div class="header">
        <span class="main-title">{{h2}}</span>
        <span class="title">{{slides[currentImage].title}}</span>
        <span class="position">({{(1 + currentImage) + '/' + totalImages}})</span>
        <div class="slides-thumbnails">
          <div
            class="thumbnail"
            :class="currentImage === index ? 'slide-active' : ''"
            :ref="'thumbnail' + index"
            v-for="(item, index) in slides"
            :key="index"
            @click="onThumbnailClick(index)"
          >
            <div data-aos="zoom-in-up" data-aos-duration="200" data-aos-easing="ease-out-cubic">
              <img :src="require(`@/assets/gallery/${item.file}`)" alt />
              <img
                v-if="item.type === 'video'"
                class="video"
                src="@/assets/icons/play-arrow.svg"
                alt
              />
              <img
                v-if="item.type !== 'image' && item.type !== 'video'"
                class="virtual"
                src="@/assets/icons/360.svg"
                alt
              />
            </div>
          </div>
        </div>

        <a @click="$router.go(-1)">
          <img :src="require(`@/assets/icons/close.svg`)" alt />
        </a>
      </div>
      <div class="slides">
        <hooper
          ref="carousel"
          :itemsToShow="1"
          :itemsToSlide="1"
          :mouseDrag="false"
          :touchDrag="false"
          :wheelControl="false"
        >
          <slide v-for="(item, index) in slides" :key="index" class="slide">
            <div
              class="slide"
              data-aos="zoom-in-up"
              data-aos-duration="250"
              data-aos-easing="ease-out-cubic"
            >
              <div v-if="item.type=='video'">
                <iframe
                  :src="item.vimeo"
                  width="100%"
                  height="100%"
                  frameborder="0"
                  allow="autoplay; fullscreen"
                  allowfullscreen
                  :ref="'v' + index"
                ></iframe>
              </div>
              <div v-if="item.type=='image'">
                <img :src="require(`@/assets/gallery/${item.file}`)" alt />
              </div>
              <Digital3D :view="item.view" v-if="item.type=='virtual'" />
              <Digital3DMap :view="item.view" v-if="item.type=='virtual-map'" />
            </div>
          </slide>
        </hooper>
        <div class="gallery-buttons">
          <button class="left" @click="onDirectionClick(-1)">
            <img src="@/assets/icons/gallery-arrow.svg" alt />
          </button>
          <button class="right" @click="onDirectionClick(1)">
            <img src="@/assets/icons/gallery-arrow.svg" alt />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Player from "@vimeo/player";
import { Hooper, Slide } from "hooper";
import Digital3D from "@/components/patterns/Digital3D";
import Digital3DMap from "@/components/patterns/Digital3DMap";
export default {
  components: {
    Hooper,
    Slide,
    Digital3D,
    Digital3DMap
  },
  props: {
    h2: String,
    slides: Array
  },
  data() {
    return {
      currentImage: 0
    };
  },
  computed: {
    totalImages: function() {
      return this.slides.length;
    }
  },
  watch: {
    currentImage: function(val) {
      if (val >= 0) {
        const _slide = this.$refs["thumbnail" + val][0];
        _slide.scrollIntoView({
          behavior: "smooth",
          inline: "end",
          block: "end"
        });
      }
    }
  },
  methods: {
    onThumbnailClick(index) {
      let ele = this.$refs["carousel"];
      this.playVideo(index);
      this.currentImage = index;
      ele.slideTo(this.currentImage);
    },
    playVideo(index) {
      if (this.$refs["v" + this.currentImage]) {
        const oldVimeoPlayer = new Player(
          this.$refs["v" + this.currentImage][0]
        );
        oldVimeoPlayer.pause();
      }
      if (this.$refs["v" + index]) {
        const newVimeoPlayer = new Player(this.$refs["v" + index][0]);
        newVimeoPlayer.play();
      }
    },
    onDirectionClick(_direction) {
      let ele = this.$refs["carousel"];
      let newIndex = this.currentImage + _direction;
      if (newIndex < 0) {
        newIndex = this.slides.length - 1;
      } else if (newIndex >= this.slides.length) {
        newIndex = 0;
      }
      this.playVideo(newIndex);
      this.currentImage = newIndex;

      ele.slideTo(this.currentImage);
    }
  }
};
</script>

<style lang="scss" scoped>
.gallery-buttons {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  pointer-events: none;
  button {
    width: 50px;
    height: 100%;
    pointer-events: all;
    cursor: pointer;
    img {
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
    &.left {
      padding-left: 40px;
    }
    &.right {
      padding-right: 40px;
      img {
        transform: translateY(-50%) scaleX(-1);
      }
    }
  }
}
.fcc-gallery {
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  li {
    list-style: none;
  }
  .holder {
    box-shadow: 0px 0px 15px 5px $accent-color;
    width: 90%;
    height: 80%;
    display: flex;
    flex-direction: column;
    padding: 10px;
    background: #ffffff;
    background-image: linear-gradient(180deg, #cccccc 0%, #ffffff 4%);
    position: relative;
    .header {
      height: 60px;
      overflow: hidden;
    }
    .slides {
      flex-grow: 1;
      position: relative;
      overflow: hidden;
    }
  }
  a {
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
  .slides-thumbnails {
    flex-grow: 1;
    display: inline-block;
    text-align: right;

    overflow-x: hidden;
    overflow-y: hidden;
    height: 40px;
    margin-right: 15px;
    display: inline-block;
    vertical-align: top;
    margin-left: 15px;

    .thumbnail {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      vertical-align: top;
      width: 60px;
      height: 38px;
      border: 2px solid #666666;
      transition: border 0.2s;
      overflow: hidden;
      box-sizing: border-box;
      .virtual,
      .video {
        position: absolute;
        top: 0;
        left: 0;
        transform: translateX(50%);
        width: 50%;
        object-fit: contain;
        object-position: center;
      }
      .video {
        height: 50%;
        top: 50%;
        transform: translate(50%, -50%);
      }
      &:not(:last-of-type) {
        margin-right: 10px;
      }
      &.slide-active {
        border: 2px solid $secondary-color;
      }
    }
  }
  #pano {
    height: 100%;
  }
  .slide {
    > div > img,
    > div {
      height: inherit;
      width: 90vw;
      object-fit: cover;
      object-position: center;
    }
  }

  .thumbnail {
    div {
      width: 60px;
      height: 100%;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
  .header {
    font-size: 32px;
    color: #002f87;
    letter-spacing: 0;
    text-transform: uppercase;
    padding: 12px 16px;
    padding-top: 0;
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: baseline;
    white-space: nowrap;
    .title {
      font-weight: bold;
    }
    .position {
      font-size: 14px;
      margin-left: 10px;
    }
    a {
      cursor: pointer;
      align-self: center;
    }
  }
}
@media (max-width: 1000px) {
  .fcc-gallery {
    .position {
      display: none;
    }
    .slides-thumbnails {
      display: none;
    }
    .main-title {
      display: none;
    }
    a {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>
<style lang="scss">
.hooper {
  height: 100%;
  overflow: hidden;
}
.hooper-liveregion {
  display: none;
}
.hooper-track {
  display: flex;
}
.hooper-list {
  height: 100%;
  padding: 0;
  overflow: hidden;
  ul {
    padding: 0;
    height: 100%;
    li {
      padding: 0;
      height: 100%;
      flex-shrink: 0;
    }
  }
}
</style>